import { CRow, CCol, CInput, CLabel, CFormGroup, CInputGroup } from '@coreui/react';
import React, { useState } from 'react';
import ButtonWithLoader from '../../components/ButtonWithLoader';
import _t from 'counterpart';
import { useGetSetting } from './hooks';
import { useMutation } from 'react-query';
import { findErrorFromValidation, handleFormError } from '../../helpers';
import { updateVoicespin } from '../../services/BackendService';
import toast from 'react-hot-toast';

interface IProps {
  onChange: () => void;
}

const VoicespinIntegration = ({ onChange }: IProps) => {
  const [voicespinUrl, setVoicespinUrl] = useState<string>('');

  const requestUrlQuery = useGetSetting('VOICESPIN_REQUEST_URL', 'voicespin-url', {
    retry: false,
    refetchOnWindowFocus: false,
    onSuccess: (value: string) => {
      setVoicespinUrl(value);
    },
  });

  const updateVoicespinMutation = useMutation((url: string) => updateVoicespin(url), {
    onError: (error: any) => {
      handleFormError(error);
    },
    onSuccess: () => {
      toast.success(_t('integrations.voicespin-configured'));
      onChange();
    },
  });

  const callUpdateVariableMutation = () => {
    updateVoicespinMutation.mutate(voicespinUrl);
  };

  const setFormValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVoicespinUrl(e.target.value);
  };

  const findError = (paramName: string) => {
    const error = findErrorFromValidation(updateVoicespinMutation.error, paramName);
    return error;
  };

  return (
    <>
      <CRow>
        <CCol>
          <p>{_t('integrations.voicespin-paragraph-one')}</p>
          <p>{_t('integrations.voicespin-paragraph-two')}</p>
          <p>{_t('integrations.voicespin-paragraph-three')}</p>
        </CCol>
      </CRow>
      <CRow>
        <CCol md={12}>
          <CFormGroup>
            <CLabel htmlFor="url">{_t(`integrations.voicespin-url`)}</CLabel>
            <CInputGroup>
              <CInput
                type="text"
                id="url"
                name="url"
                value={voicespinUrl}
                onChange={setFormValue}
                className="instrument-input-height"
              />
            </CInputGroup>
            {requestUrlQuery.error && (
              <CLabel className="text-danger">{_t('integrations.voicespin-url-failed')}</CLabel>
            )}
            {findError('url') && <CLabel className="text-danger">{findError('url')}</CLabel>}
          </CFormGroup>
        </CCol>
        <CCol md={12} className="d-flex justify-content-end">
          <ButtonWithLoader
            isLoading={updateVoicespinMutation.isLoading}
            onClick={callUpdateVariableMutation}
            buttonColor="primary"
            spinnerColor="secondary"
            title={_t('action.save')}
            className="btn-md"
            showText={false}
            disabled={voicespinUrl === ''}
          />
        </CCol>
      </CRow>
    </>
  );
};

export default VoicespinIntegration;
